import { defineComponent, ExtractPropTypes } from 'vue';
import { createNamespaceBem, makeStringProp, makeCustomProp, makeNumberProp } from '@/utils';
import { Radio, Checkbox } from 'vant';

const { name, bem } = createNamespaceBem('pkg-checkbox');

export enum PkgCheckboxType {
  radio = 'radio',
  checkbox = 'checkbox',
}

export enum PkgTheme {
  blue = 'blue',
  orange = 'orange',
  green = 'green',
  purple = 'purple',
}

export type PkgThemeType = 'default' | keyof typeof PkgTheme;

export type CheckboxType = keyof typeof PkgCheckboxType;

const pkgCheckboxProps = {
  data: makeCustomProp<any>(Object, null),
  index: makeNumberProp<number>(0),
  theme: makeStringProp<PkgThemeType>('default'),
  title: makeStringProp(''),
  desc: makeStringProp(''),
  type: makeStringProp<CheckboxType>('radio'),
  activePkg: makeNumberProp<number>(0),
  checkStatus: makeCustomProp<any>([Boolean, Number, Array, String], false),
  disabled: makeNumberProp<number>(0),
};

export type PkgCheckboxProps = ExtractPropTypes<typeof pkgCheckboxProps>;

export default defineComponent({
  name,
  props: pkgCheckboxProps,
  emits: ['clickPkg', 'clickCheckbox', 'update:activePkg', 'update:checkStatus'],
  setup(props, { emit }) {
    const pkg = ref(props.checkStatus);
    const pkgClick = () => {
      emit('clickPkg', props.data);
      emit('update:activePkg', props.index);
    };
    const checkboxClick = () => {
      emit('clickCheckbox', props.data);
      emit('update:checkStatus', pkg.value);
    };
    return () => (
      <div class={bem([props.theme])}>
        <div class={bem('pkg', { active: props.index === props.activePkg })} onClick={pkgClick}>
          <div class={bem('title')}>{props.title}</div>
          {/* <div class={bem('desc')}>{props.desc}</div> */}
        </div>
        <div class={bem('checkbox')}>
          {props.type === 'checkbox' ? (
            <Checkbox
              v-model={pkg.value}
              name={props.checkStatus}
              shape="square"
              disabled={!!props.disabled}
              onClick={checkboxClick}
            />
          ) : (
            <Radio v-model={pkg.value} name={props.checkStatus} onClick={checkboxClick} disabled={!!props.disabled} />
          )}
        </div>
      </div>
    );
  },
});
